<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  }
})

const height = computed(() => props.height ? props.height : 41)
const width = computed(() => height.value * 64 / 54)

</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 64 54"
       xmlns="http://www.w3.org/2000/svg"
       xml:space="preserve"
       style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,0,-5.29162)">
        <path id="path828-5"
              d="M53.404,58.708L64,5.292L46.82,5.311L40.736,38.028L28.615,5.31L10.012,5.31L0,58.701L17.765,58.701L23.824,25.085L35.587,58.701L53.404,58.708Z"
              style="fill:rgb(141,198,64);fill-rule:nonzero;"/>
    </g>
</svg>
</template>

<style scoped lang="less">

</style>
